(function () { if (!LN.Core) throw new Error("LN.Core missing"); })();

(function (AppEvent, Model) {
    'use strict';


    AppEvent.sendEvent = function (event, data) {
        if (Model.Embed.Mobile) {
          
            var request = {
                event: event,
                data: data
            };
            console.log('AppEvent');
            console.log(request);
            try {
                webkit && webkit.messageHandlers.ios.postMessage(JSON.stringify(request));
            } catch (err) {
                console.error('Error IOs: ' + err.message);
            }
            try {
                android && android.performClick(JSON.stringify(request));
            } catch (err) {
                console.error('Error Android: ' + err.message);
            }
        }
    };

})(LN.AppEvent, LN.Model);


// WEBPACK FOOTER //
// ./Statics/scripts/paywall/core/appEvent.js